import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './IMSLink.module.scss';
import { determineIfExternal, getPath } from 'routes/_utils';

/**
 * Wrapper for MenuItemResolver anchor link
 * if url is a known invalid link, render children only
 * @returns IMSLink component
 */
const IMSLink = ({ url, children, ...restProps }) => {
	return (
		<>
			{url === undefined || url === null || url === '#' || url === '' ? (
				<div className={styles.imsLink}>{children}</div>
			) : determineIfExternal(url.trim()) ? (
				<a className={styles.imsLink} href={url.trim()} {...restProps}>
					{children}
				</a>
			) : (
				<Link
					className={styles.imsLink}
					to={getPath(url)}
					{...restProps}
				>
					{children}
				</Link>
			)}
		</>
	);
};

IMSLink.propTypes = {
	url: PropTypes.string,
	children: PropTypes.element,
};

export default IMSLink;
